export default __webpack_public_path__ + "static/media/FiraSans-SemiBold.8990e55e.woff";